// extracted by mini-css-extract-plugin
export var layoutContainer = "_dc-0";
export var layoutContainerNoRounding = "_dc-6";
export var layoutContainerOpen = "_dc-5";
export var layoutContainerResizing = "_dc-1";
export var mainContent = "_dc-2";
export var resizeDivider = "_dc-3";
export var slidePanel = "_dc-4";